<template>
  <div class="account-view">
    <div class="account-view__content">
      <div
        class="container has-text-left"
        v-if="!confirmationCodeError && optinId !== ''"
      >
        <div class="hero is-medium">
          <div class="hero-body">
            <div
              v-html="$t('register.messages.registrationSuccessful')"
              class="mb-6"
            />
            <router-link
              :to="
                Object.entries($store.getters.allCartItems).length > 0 &&
                $store.getters.isUserLoggedIn
                  ? '/payment-details'
                  : '/login'
              "
              class="button is-primary-dark is-large"
              >Login
            </router-link>
          </div>
        </div>
      </div>
      <div class="account-view__section" v-else>
        <div class="mb-4 container is-max-desktop">
          <h1 class="title is-3 has-text-grey">
            {{ $t("register.headline") }}
          </h1>
          <p
            class="has-text-danger is-size-4"
            v-if="confirmationCodeError"
            v-html="$t('register.messages.registrationCodeInvalid')"
          />
        </div>
      </div>
      <form
        @submit.prevent="registerUser"
        autocomplete="on"
        v-if="optinId === ''"
      >
        <div class="account-view__section has-background-grey-lighter">
          <div class="mb-4 container is-max-desktop">
            <div class="columns is-multiline">
              <div class="column is-half-tablet">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3">{{
                    $t("register.inputLabels.userName")
                  }}</label>
                  <div class="control">
                    <input
                      v-model="userName"
                      class="input"
                      type="text"
                      minlength="4"
                      maxlength="20"
                      pattern="^((?!@).)*$"
                      :placeholder="$t('register.inputLabels.userName')"
                    />
                  </div>
                </div>
              </div>
              <div class="column is-half-tablet">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3">{{
                    $t("register.inputLabels.email")
                  }}</label>
                  <div class="control">
                    <input
                      v-model="email"
                      class="input"
                      type="email"
                      :placeholder="$t('register.inputLabels.email')"
                    />
                  </div>
                </div>
              </div>

              <div class="column is-half-tablet">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3">{{
                    $t("register.inputLabels.password")
                  }}</label>
                  <div class="control">
                    <input
                      v-model="password"
                      class="input"
                      type="password"
                      :placeholder="$t('register.inputLabels.password')"
                      :title="passwordMessage"
                      minlength="8"
                      maxlength="20"
                    />
                  </div>
                </div>
              </div>
              <div class="column is-half-tablet">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3">{{
                    $t("register.inputLabels.repeatPassword")
                  }}</label>
                  <div class="control">
                    <input
                      v-model="passwordRepeat"
                      class="input"
                      type="password"
                      :placeholder="$t('register.inputLabels.password')"
                      :pattern="password"
                    />
                  </div>
                </div>
              </div>
              <div class="column is-full">
                <div class="status-message">
                  <p v-html="userNameMessage" class="is-size-4" />
                  <p class="is-size-4">
                    {{ passwordMessage }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <address-form v-model="address" />
        <div class="account-view__section my-5">
          <div class="container is-max-desktop">
            <div class="column is-full">
              <div class="has-checkbox">
                <label class="checkbox">
                  <input class="control" type="checkbox" v-model="agb" />
                  {{
                    $t("footer.newsletter.inputLabels.privacyStatementCheckbox")
                  }}
                  <RouterLink class="link link-primary" to="/datenschutz">
                    <span>
                      {{ $t("footer.newsletter.inputLabels.privacyStatement") }}
                    </span>
                  </RouterLink>
                  .*
                </label>
              </div>
            </div>
            <div class="column is-full">
              <transition nam="fade">
                <span
                  class="has-text-success is-size-4"
                  v-if="registrationIsSent && !registrationError"
                >
                  {{ $t("register.messages.confirmationEmailSent") }}
                </span>
                <p
                  class="has-text-black is-size-4"
                  v-if="registrationError"
                  v-html="displayErrorMessage"
                ></p>
              </transition>
            </div>
            <div class="column is-full login-form__actions">
              <button
                :disabled="
                  !userNameIsValid ||
                  email.length < 1 ||
                  !(
                    password.trim().length > 7 && password === passwordRepeat
                  ) ||
                  !agb ||
                  !allRequiredFieldsAreFilled
                "
                :class="{ 'is-loading': loading }"
                type="Submit"
                class="button is-primary-dark px-6"
              >
                {{ $t("register.mainActions.register") }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AddressForm from "../Forms/AddressForm";
import { mapGetters } from "vuex";

export default {
  name: "Register",
  components: { AddressForm },
  data() {
    return {
      userName: "",
      password: "",
      passwordRepeat: "",
      email: "",
      registrationIsSent: false,
      loading: false,
      message: "",
      agb: false,
      optinId: "",
      registrationError: false,
      confirmationCodeError: false,
      defaultErrorMessage:
        "Hier scheint ein Fehler aufgetreten zu sein.\n Bitte prüfen Sie Ihre E-Mails oder versuchen Sie es zu einem späteren Zeitpunkt erneut.",
      serverErrorMessage: null,
      address: {
        billingAddress: {
          street: "",
          city: "",
          country: "",
          countryId: "",
          postalCode: "",
          company: "",
          addressSuffix: "",
          title: "",
          firstname: "",
          lastname: "",
          vatRegistrationNumber: "",
        },
        shippingAddress: {
          street: "",
          city: "",
          postalCode: "",
          company: "",
          addressSuffix: "",
          firstname: "",
          lastname: "",
          country: "",
          countryId: "",
        },
        shippingAddressDiffersFromBillingAddress: false,
      },
      requiredShippingFields: [
        "firstname",
        "lastname",
        "street",
        "postalCode",
        "city",
        "countryId",
      ],
      requiredBillingFields: [
        "firstname",
        "lastname",
        "street",
        "postalCode",
        "city",
        "countryId",
      ],
    };
  },
  computed: {
    ...mapGetters(["availableShippingCountries"]),
    passwordMessage() {
      if (this.password.length === 0) {
        return "";
      } else if (this.password.length < 8) return "Mindestens 8 Zeichen.";
      else if (this.password.length > 20) return "Höchstens 20 Zeichen.";
      else {
        if (this.passwordRepeat.length === 0) {
          return "";
        } else {
          if (this.passwordRepeat.length !== this.password.length) {
            if (this.passwordRepeat !== this.password) {
              return "Passwörter stimmen nicht überein.";
            } else {
              return "";
            }
          }
        }
      }
      return "";
    },
    userNameMessage() {
      if (this.userName.length > 0 && this.userName.length < 4) {
        return this.$i18n.t("register.messages.userNameTooShort");
      } else if(this.userName.length > 20) {
        return 'Ihr Nutzername enthält höchstens 20 Zeichen.'
      }

      if (this.userName.includes("@")) {
        return this.$i18n.t("register.messages.userNameInvalid");
      }
    },
    userNameIsValid() {
      return this.userName.length >= 4 && this.userName.length <= 20 &&!this.userName.includes("@");
    },
    displayErrorMessage() {
      return this.serverErrorMessage || this.defaultErrorMessage;
    },
    allRequiredFieldsAreFilled() {
      let result = true;
      this.requiredBillingFields.forEach((value) => {
        if (!this.address.billingAddress[value]) {
          result = false;
        }
      });
      if (this.address.shippingAddressDiffersFromBillingAddress) {
        this.requiredShippingFields.forEach((value) => {
          if (!this.address.shippingAddress[value]) {
            result = false;
          }
        });
      }
      return result;
    },
  },
  methods: {
    registerUser() {
      this.loading = true;
      this.$store
        .dispatch("registerUser", {
          username: this.userName,
          password: this.password,
          email: this.email,
          billingAddress: this.address.billingAddress,
          shippingAddress: this.address.shippingAddressDiffersFromBillingAddress
            ? this.address.shippingAddress
            : this.address.billingAddress,
        })
        .then(() => {
          setTimeout(() => {
            this.loading = false;
            this.registrationIsSent = true;
            this.registrationError = false;
            this.userName = "";
            this.password = "";
            this.passwordRepeat = "";
            this.email = "";
          }, 1000);
        })
        .catch((error) => {
          if (error.response) {
            switch (error.response.status) {
              case 409:
                this.serverErrorMessage = this.$i18n.t(
                  "register.messages.userNameAlreadyExists",
                  { username: this.userName }
                );
                break;
              default:
                this.serverErrorMessage = error;
            }
          }
          console.log(error.status);

          this.loading = false;
          this.registrationIsSent = true;
          this.registrationError = true;
        });
    },
    fetchCMSData() {
      this.$store.dispatch("fetchCMSPage", { urlSlug: "/" });
    },
  },
  created() {
    this.fetchCMSData();
  },
  async mounted() {
    if (this.$route.params.optinId) {
      this.optinId = this.$route.params.optinId;

      try {
        await this.$store.dispatch("optinUser", this.optinId);
      } catch (e) {
        console.log("ERROR");
        this.confirmationCodeError = true;
      }
    }
    await this.$store.dispatch("fetchShippingCountries");
    let storedPaymentDetails = this.$store.getters.paymentDetails;
    this.email = storedPaymentDetails.email || "";

    if (!this.address.billingAddress.countryId) {
      this.address.billingAddress.countryId =
        this.availableShippingCountries[0]._id;
      this.address.shippingAddress.countryId =
        this.address.billingAddress.countryId;
    }
  },
};
</script>

<style scoped>
</style>